export enum USER_FEEDBACKS {
    POSITIVE = 'POSITIVE',
    NEGATIVE = 'NEGATIVE',
}
